export default __webpack_public_path__ + "static/media/smart.6e8be0fd.jpg";